import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { AttachmentEntity } from "../../../Data/MedicinalProductData/AttachmentEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { DateUtil } from "../../../DateUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeAttachment extends BaseNode {

  constructor(injector: Injector, model: any, parent: any) {

    super(injector,
      new AttachmentEntity(injector, model),
      `${model.languagecode} - ${model.attachmentname}`);
    this.parent = parent;
    this.ioc!.get(Art57Section).generateNumColumValue(this);

  }

  public getListItem(): any[] {
    return [this.data.model.ev_Code, this.ioc!.get(LookupGetService).retrieveValueFromCache('attachmenttype', this.data.model.attachmenttype),
    this.data.model.ownerid, this.data.model.ownerhqid,
    this.ioc!.get(LookupGetService).retrieveValueFromCache('language', this.data.model.languagecode),
    this.data.model.attachmentname, this.data.model.filename, 'Not available',
    this.data.model.filename.substring(this.data.model.filename.lastIndexOf('.') + 1),
    DateUtil.importDate(this.data.model.attachmentversiondate, this.data.model.versiondateformat),
      'CCYYMMDD', this.data.model.attachmentversion
    ];
  }

  override cloneNode(newParent: BaseNode): BaseNode|undefined {
    let clonedNode: TreeNodeAttachment = new TreeNodeAttachment(
      this.ioc!,
      this.data.model,
      newParent
    );

    clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
    clonedNode.refreshLabel();
    clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning || environment.userPreferences.alwaysAutoexpandNodes)

    this.children?.forEach((child) => {
      let childToClone = child as BaseNode;
      let clonedChildren = childToClone.cloneNode(clonedNode);
      if (clonedChildren) {
          clonedNode.children?.push(clonedChildren);
          clonedChildren.refreshLabel();
      }
    });

    // property diesn't exists      clonedNode.cloningNode = false;
    return clonedNode;
  }
}